
import React from 'react';
import { Card,Button,Empty} from "antd"
import RegisterPermissionLetterCenter from "./RegisterPermissionLetter/RegisterPermissionLetterCenter"
import ViewerPDF from "./../../Layouts/PDF/Viewer/ViewerPDF"
import { useState,useCallback,useEffect,useMemo } from "react"
import CenterService from "../../../services/CenterService";
import { useHistory,useLocation,useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../Auth/userReducer';


const RolesPermited=[
    "Coordinador del centro",
]


export default function PermissionCenter(Props) {
    const {Center}=Props
    const user= useSelector(selectUser)
    const [viewModal,setViewModal]=useState(false);
    const [modalOption,setModalOption]=useState(false);
    const [documentApprovalPDF,setDocumentApprovalPDF]=useState()
    const [displayViewerPDF,setDisplayViewerPDF]=useState(false);
    const {id:CenterID}=useParams()
    const history = useHistory();
    const { search } = useLocation();
    const searchParams = useMemo(
        () => new URLSearchParams(search),[search]
      );
    // const [filePDF,setFilePDF]=useState(null)
    const [isUploadPDF,setIsUploadPDF]=useState(false)
    const [permissionComponents,setPermissionComponents]=useState(false)

    const propsModal={
        open:viewModal,
        // onCancel:()=>{setViewModal(false)},
        // onOk:(file)=>createPermissionLetterCenter(file)
        footer:null,
    }

    const propsOptions={
        onCancel:()=>{setViewModal(false)},

    }

    const verificityPermissionRol=()=>{
        // console.log("user.rolName",user.rolName)
        return RolesPermited.includes(user.rolName)
    }

    const getDocumentApproval=useCallback((centerId)=>{
        CenterService.getDocumentApprovalByCenter(centerId).then((res)=>{
            let DocumentApprovalPDF=res.data?.response
            setDocumentApprovalPDF(DocumentApprovalPDF)
            setDisplayViewerPDF(DocumentApprovalPDF===undefined? true:false)
            // setFilePDF(DocumentApprovalPDF?.documentApprovalAttachment)
        })
    })  
    const updatedPDF=(response)=>{
        setIsUploadPDF(response);
    }
    useEffect(()=>{
        getDocumentApproval(CenterID)
        if (searchParams.get('option')!=="PermissionLetter") {
            searchParams.set('option', 'PermissionLetter');
            history.replace({ search: searchParams.toString() });
        }
        setPermissionComponents(verificityPermissionRol())  
        setIsUploadPDF(false)
    },[isUploadPDF])
    
    
    return(
    <>
        {permissionComponents &&(<Card>
            { displayViewerPDF?
            <Button onClick={()=>{
                setViewModal(true)
                setModalOption("create")
            }}
            >Subir PDF</Button>
            :
            <Button onClick={()=>{
                setViewModal(true)
                setModalOption("update")
            }}
            >Cambiar PDF</Button>
            }
        </Card>)}
        <RegisterPermissionLetterCenter 
        propsModal={propsModal}
        propsOptions={propsOptions}
        propsCenter={Center}
        propsIsUploadPDF={updatedPDF}
        propsModalOption={modalOption}
        propsDataUpdate={documentApprovalPDF?.documentApprovalName}
        >
        </RegisterPermissionLetterCenter>
        <Card>
        {displayViewerPDF? 
        <Empty/>:
        <ViewerPDF
        FileName={documentApprovalPDF?.documentApprovalName}
        FileDocument={documentApprovalPDF?.documentApprovalAttachment}
        ></ViewerPDF>
            }
        </Card>
    </>)
}